// src/pages/broadcast.contract.ts —— Bot 广告推送（0049，06 C-33）Console 侧契约入口：类型一律取 shared/src/api/types（Bc*），
// 路由一律取 shared/src/api/routes（ROUTES 已登记，routes.contract.test 与后端 TestRouteContract 双向核对）。
// 传输只委托正式 ApiClient（ctx.gp.api.call / blob）：鉴权头、401 续期 / 重放、会话终止、403/1501 刷新 /me、X-Activity: passive 均由其统一处理，
// 本文件不再自建 fetch。调用方只经 bcCall / bcBlob（路由 key 收窄到本功能集合，误用其他路由在编译期报错）。
import type { CallOptions } from '../../../shared/src/api/client';
import type { RouteKey } from '../../../shared/src/api/routes';
import type { BcButton, BcPage } from '../../../shared/src/api/types';
import type { AdminCtx } from '../domains/types';

export type {
  BcBotOption,
  BcButton,
  BcCampaign,
  BcCampaignInput,
  BcDelivery,
  BcEstimate,
  BcFile,
  BcFilterCard,
  BcFilterLang,
  BcPage,
  BcRun,
  BcRunStatus,
  BcSchedule,
  BcScheduleKind,
  BcSettings,
  BcStatus,
} from '../../../shared/src/api/types';

export type BcButtonKind = BcButton['kind'];

// Console 侧推广推送路由（shared ROUTES 子集）：/api/admin/broadcast*、图片读取、个人设置 Telegram ID
export type BcRouteKey = Extract<
  RouteKey,
  `${string} /api/admin/broadcast${string}` | 'GET /api/admin/files/broadcast/{id}' | 'PUT /api/admin/me/telegram-id'
>;

// 列表分页（AdminPage：list / total / page / size）在边界补齐缺省值：后端异常省略字段时页面仍按请求页码渲染，不出现 undefined
export function bcPage<T>(raw: Partial<BcPage<T>> | null | undefined, page: number, size: number): BcPage<T> {
  const list = Array.isArray(raw?.list) ? raw.list : [];
  return {
    list,
    total: typeof raw?.total === 'number' ? raw.total : list.length,
    page: typeof raw?.page === 'number' ? raw.page : page,
    size: typeof raw?.size === 'number' ? raw.size : size,
  };
}

export function bcCall<T>(ctx: AdminCtx, route: BcRouteKey, o: CallOptions = {}): Promise<T> {
  return ctx.gp.api.call<T>(route, o);
}

export function bcBlob(ctx: AdminCtx, route: BcRouteKey, o: CallOptions = {}): Promise<{ blob: Blob; filename: string | null }> {
  return ctx.gp.api.blob(route, o);
}
